export default __webpack_public_path__ + "/dist/images/Instagram.384bd513694b58e722e761c89e2e84d4.svg";